import { render, staticRenderFns } from "./PersonSearchInput.vue?vue&type=template&id=39b6f028&scoped=true"
import script from "./PersonSearchInput.vue?vue&type=script&lang=ts"
export * from "./PersonSearchInput.vue?vue&type=script&lang=ts"
import style0 from "./PersonSearchInput.vue?vue&type=style&index=0&id=39b6f028&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b6f028",
  null
  
)

export default component.exports